import React, { useRef } from "react";
import { StyledNotificationFacet } from "./styles";
import Input from "../UI/Input";
import { translate } from "../../utils/translations/translate";
import Button from "../UI/Button";
import { Label } from "../UI/styles";
export const NotificationsFacet = ({onFilterTypeChange}) => {
  const subjectRef = useRef(null);
  const statusRef = useRef({
    notification: true,
    alert: true,
  });
  const typeRef = useRef({
    read: true,
    unread: true,
  });
  const handleStatusFilterChange = (field, value) => {
    statusRef.current[field] = value;
  };
  const handleTypeFilterChangeRef = (field, value) => {
    typeRef.current[field] = value;
  };
  const getSubjectInputValue = ()=>{
    return subjectRef.current?.querySelector("input")?.value;
  } 
  const triggerFilter = () => {
    const subjectInputVal = getSubjectInputValue();
    const { read, unread } = typeRef.current;
    const { alert, notification } = statusRef.current;
    let notificationTypeParam = undefined;
    if (alert && !notification) {
      notificationTypeParam = "Alert";
    } else if (notification && !alert) {
      notificationTypeParam = "Notification";
    }
    let isViewedParamVal = undefined;
    if (read && !unread) {
      isViewedParamVal = "true";
    } else if (unread && !read) {
      isViewedParamVal = "false";
    }
    const addtionalParams = {
      subject: subjectInputVal,
      isViewed: isViewedParamVal,
      notificationType: notificationTypeParam,
    };
    onFilterTypeChange(addtionalParams);
  };
  return (
    <StyledNotificationFacet className="tma_facets_content">
      <section className="tma_facet-section">
        <Input
          labelText={translate("labels.subject")}
          id={"tma_subject_text"}
          helperText={translate("labels.filterHelperText")}
          inputRef={subjectRef}
          onKeyDown={(e)=>{
             if(e.key === "Enter"){
                e.preventDefault();
                const hasValue = getSubjectInputValue();
                if(hasValue){
                    triggerFilter();
                }
             }
          }}
        />
      </section>
      <section className="tma_facet-section">
        <h3>{translate("labels.messageType")}</h3>
        <p className="tma_blue-highlighter" style={{display:"none"}}>
          <span>{translate("labels.selectAll")}</span>
          <span>{translate("labels.selectNone")}</span>
        </p>
        <div className="tma_type_highlighter">
          <div className="form-control">
            <input
              type="checkbox"
              id="notification-checkbox"
              name="notification-checkbox"
              defaultChecked
              onChange={(e) => {
                handleStatusFilterChange("notification", e.target.checked);
              }}
            />
            <Label htmlFor="notification-checkbox">
              {translate("labels.notification")}
            </Label>
          </div>
          <div className="form-control">
            <input
              type="checkbox"
              defaultChecked
              id="alert-checkbox"
              name="alert-checkbox"
              onChange={(e) => {
                handleStatusFilterChange("alert", e.target.checked);
              }}
            />
            <Label htmlFor="alert-checkbox">{translate("labels.alert")}</Label>
          </div>
        </div>
      </section>
      <section className="tma_facet-section">
        <h3>{translate("labels.messageStatus")}</h3>
        <div className="form-control">
          <input
            type="checkbox"
            defaultChecked
            onChange={(e) => {
              handleTypeFilterChangeRef("unread", e.target.checked);
            }}
            id="unread-checkbox"
            name="unread-checkbox"
          />
          <Label htmlFor="unread-checkbox">{translate("labels.unread")}</Label>
        </div>
        <div className="form-control">
          <input
            type="checkbox"
            defaultChecked
            onChange={(e) => {
              handleTypeFilterChangeRef("read", e.target.checked);
            }}
            id="read-checkbox"
            name="read-checkbox"
          />
          <Label htmlFor="read-checkbox">{translate("labels.read")}</Label>
        </div>
      </section>
      <section className="tma_facet-section">
        <Button
          className={"primary-outline"}
          text={translate("labels.filterMessages")}
          variantStyle="primary"
          type="button"
          onClick={triggerFilter}
        />
      </section>
    </StyledNotificationFacet>
  );
};
